import React, { useCallback, useEffect, useState } from "react";
import { AprobarSolicitudesHEDTO } from "../Aprobacion Solicitudes/TypesAprobacionHE";
import { Pagination, PaginationItem, PaginationLink, Col, Input, Row, Label, Table } from "reactstrap";
import { ObtenerFechaFromIsoFormat } from "functions/DatesFunctions";
import { ReactComponent as IconPdf } from "../../../../assets/icons/HorasExtras/PDF.svg"
import Cargando from "components/Varios/Cargando";
import { VistaPreviaSolicitudHETHoUsuario } from "components/Admin/Horas Extras/Revisar Solicitudes Horas Extras/functionsAprobarSolicitudesHE";
import { showAlert } from "components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras";
import ModalCargando from "components/Varios/ModalCargando";
import ModalVistaPreviaDocumentos from "components/Varios/Modals/ModalVistaPreviaDocumentos";

type PropsHistorialSolicitudesDUHE = {
    informacionContenido: AprobarSolicitudesHEDTO[],
    loading: boolean,
    isAprobada: boolean,
}

export default function TablaHistorialSolicitudesDUHE(props: PropsHistorialSolicitudesDUHE) {
    const { informacionContenido, loading, isAprobada } = props;

    const [contenido, setcontenido] = useState<AprobarSolicitudesHEDTO[]>(informacionContenido);
    const [loadingAccion, setloadingAccion] = useState<boolean>(false);
    const [urlSolicitud, seturlSolicitud] = useState<string>("");

    const [sortColumn, setSortColumn] = useState<string | null>('');
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortToggle, setSortToggle] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');

    //revisar funcion para el documento que se quiere obtener
    async function GenerarVistaPreviaAprobatoriaHE(idSolicitud: number) {
        setloadingAccion(true)
        const respuestaVistaPrevia = await VistaPreviaSolicitudHETHoUsuario(idSolicitud, "DIRECTIVO");

        if (respuestaVistaPrevia.status === 200 && respuestaVistaPrevia.dataResponse && typeof (respuestaVistaPrevia.dataResponse) === "string") {
            seturlSolicitud(respuestaVistaPrevia.dataResponse)
        }
        else {
            showAlert("No es posible cargar la vista previa del documento", false);
        }
        setloadingAccion(false)
    }

    useEffect(() => {
        handleSort("nombres");
    }, []);

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;

    //reorganiza ascendente o descendente los nombres
    const handleSort = (column) => {
        const isAsc = sortColumn === column && sortDirection === 'asc';
        setSortColumn(column);
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortToggle(!sortToggle); // Cambia el estado para forzar re-render
    };

    const applySorting = (data) => {
        if (!sortColumn) return data;

        if (data) {
            const sortedData = [...data].sort((a, b) => {
                if (a && b) {
                    var valA = a[sortColumn];
                    var valB = b[sortColumn];

                    if (typeof valA === "string" && typeof valB === "string") {
                        // Sort strings using localeCompare
                        return valA.localeCompare(valB) * (sortDirection === 'asc' ? 1 : -1);
                    } else if (typeof valA === "number" && typeof valB === "number") {
                        // Sort numbers directly
                        return (valA - valB) * (sortDirection === 'asc' ? 1 : -1);
                    }

                    // Handle potential cases where types are mixed or unexpected
                    return 0;
                }

                return 0;


            });
            return sortedData;
        }

    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reiniciar la paginación cuando se busca
    };
    //filtrado para el buscador
    const filteredSolicitudes = contenido.filter(solic =>
    (solic.nombres.toLowerCase().includes(searchTerm.toLowerCase()) ||
        solic.regimen.toLowerCase().includes(searchTerm.toLowerCase()) ||
        solic.identificacion.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    //presenta las filas asignadas
    const sortedSolicitudes = applySorting(filteredSolicitudes);
    let currentRows:AprobarSolicitudesHEDTO[] = sortedSolicitudes.slice(indexOfFirstRow, indexOfLastRow);

    //obtiene el numero de paginas segun la cantidad de datos
    const pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(filteredSolicitudes.length / rowsPerPage); i++) {
        pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map(number => (
        <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink onClick={() => setCurrentPage(number)}>
                {number}
            </PaginationLink>
        </PaginationItem>
    ));

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setRowsPerPage(parseInt(event.target.value));
        setCurrentPage(1);
    };

    const contenidoTabla = useCallback(() => {
        if (currentRows) {
            return (
                <div className="table-responsive">
                    <Table className="table_planificacion_he table-bordered">
                        <thead className="cabeceras_tabla_servidores_act_he">
                            <tr>
                                <th colSpan={1} align={"center"}> # </th>
                                <th colSpan={1} align={"left"} onClick={() => handleSort("fechasolicitud")}> Fecha</th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("identificacion")}> Cédula </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("nombres")}> Nombres </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("nombreestructuraorganica")}> Unidad </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("regimen")}> Régimen </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("rmu")}> RMU <br /> vigente </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("hesuplementarias")}> Total Horas <br /> Supl. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("heextraordinarias")}> Total Horas <br /> Extraord. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("hetotal")}> Total Horas <br /> Extras </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("vhesuplementarias")}> Valor Horas <br /> Supl. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("vheextraordinarias")}> Valor Horas <br /> Extraord. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("tvhorasextras")}> Valor a Recibir </th>
                                {isAprobada &&
                                    <th colSpan={1} align={"center"}> Solicitud </th>
                                }
                            </tr>
                        </thead>
                        <tbody className="tbodyAprobacionNominaTH">
                            {currentRows.map((ic, i) => {
                                const globalIndex = indexOfFirstRow + i + 1
                                return (
                                    <React.Fragment key={i}>
                                        <tr className=''>
                                            <td className="centrado"> {globalIndex} </td>
                                            <td className="centrado"> {ObtenerFechaFromIsoFormat(ic.fechasolicitud)} </td>
                                            <td className="centrado"> {ic.identificacion} </td>
                                            <td className="izquierda"> {ic.nombres} </td>
                                            <td className="centrado"> {ic.nombreestructuraorganica} </td>
                                            <td className="centrado"> {ic.regimen} </td>
                                            <td className="centrado"> {ic.rmu.toFixed(2)} </td>
                                            <td className="centrado"> {ic.hesuplementarias} </td>
                                            <td className="centrado"> {ic.heextraordinarias} </td>
                                            <td className="centrado"> {ic.hetotal} </td>
                                            <td className="centrado"> {ic.vhesuplementarias?.toFixed(2)} </td>
                                            <td className="centrado"> {ic.vheextraordinarias?.toFixed(2)} </td>
                                            <td className="centrado"> {ic.tvhorasextras?.toFixed(2)} </td>
                                            {isAprobada &&
                                                <td>
                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>
                                                        <IconPdf
                                                            className={"icono-blue-2"}
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            title="PDF Marcaciones"
                                                            onClick={() => GenerarVistaPreviaAprobatoriaHE(ic.idsolicitud)} //revisar
                                                        />
                                                    </div>
                                                </td>
                                            }
                                        </tr>
                                    </React.Fragment>
                                )
                            })}
                        </tbody>
                    </Table>
                </div>
            )
        }
    }, [currentRows])

    return (
        <React.Fragment>
            {
                loading && <Cargando />
            }
            {!loading &&
                <>
                    <Col md="3">
                        <div style={{ marginBottom: -20 }} className="d-flex align-items-center justify-content-start">
                            <Label for="rowsPerPageSelect" className="mb-0 mr-2">Mostrar</Label>
                            <select
                                id="rowsPerPageSelect"
                                value={rowsPerPage}
                                onChange={handleRowsPerPageChange}
                                className="custom-select custom-select-sm mr-2"
                                style={{ width: 'auto' }}
                            >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                            </select>
                            <Label className="mb-0">filas</Label>
                        </div>
                    </Col>
                    <Row className="d-flex justify-content-end">
                        <Col md="3">
                            <Input
                                type="text"
                                placeholder="Buscar..."
                                value={searchTerm}
                                onChange={handleSearchChange}
                                className="form-control-sm" // Reduce el tamaño del input
                            />
                        </Col>
                    </Row>
                    
                    {contenidoTabla()}

                    <Pagination size="sm" className="pagination_planificacion_he">
                        {renderPageNumbers}
                    </Pagination>

                    <ModalCargando
                        show={loadingAccion != false}
                        onClose={() => setloadingAccion(false)}
                        textoCargando='Cargando Vista'
                        size='md'
                    />

                    <ModalVistaPreviaDocumentos
                        show={urlSolicitud !== ""}
                        cargandoDatos={loadingAccion}
                        size='xl'
                        tituloModal='Solicitud de Horas Extras'
                        onClose={() => seturlSolicitud("")}
                        urlArchivo={urlSolicitud}
                        allHeight={true}
                    />

                </>
            }

        </React.Fragment>
    );


}